// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostItem_wrapper__ornqv","image":"PostItem_image__2-Y8L","content":"PostItem_content__d7jFa","date":"PostItem_date__24jCm","title":"PostItem_title__TGGLp"};